import styled from '@emotion/styled'
import { DatePicker } from 'view/components/inputs'
import { RemoveItemButton } from 'view/components/options/optionsStyles'
import { Groupbox } from 'view/components/panels'
import * as constants from 'view/styles/constants'

export const Heading = styled.h5`
  color: ${constants.CORE_PRIMARY_6};
  font-size: 13px;
  font-weight: ${constants.FontWeight.Medium};
  margin-bottom: 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ValidationIssuesContainer = styled.ul`
  font-size: 11px;
  color: ${constants.ACCENT_BAD};
  list-style-type: none;
`

export const PriceAdder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  padding: 0 8px;
  border-radius: 3px;
  border: 1px solid ${constants.CORE_PRIMARY_2};
  background-color: ${constants.CORE_PRIMARY_1};
`

export const StyledDatePicker = styled(DatePicker)`
  flex: 0 0 126px;
`

export const PriceEntry = styled.div`
  display: flex;
  flex: 0 0 153px;
  & > *:not(:last-child) {
    margin-right: 7px;
  }
  & button {
    min-width: 0;
    flex: 0 0 50px;
  }
`

export const NoPricesContainer = styled.div`
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${constants.CORE_PRIMARY_4};
`

export const PriceHeader = styled.div`
  position: sticky;
  top: 0;
  background: ${constants.CORE_PRIMARY};

  span {
    padding: 0 10px;
    height: 30px;

    :first-child {
      padding-left: 14px;
    }
  }
`

export const PriceRow = styled.div`
  background-color: ${constants.CORE_PRIMARY_1};

  &:not(:last-child) {
    margin-bottom: 6px;
  }

  span {
    padding: 0 10px;
    height: 36px;
    border-top: 1px solid ${constants.CORE_PRIMARY_2};
    border-bottom: 1px solid ${constants.CORE_PRIMARY_2};

    :first-child {
      padding-left: 13px;
      font-weight: ${constants.FontWeight.Bold};
      border-left: 6px solid ${constants.ACCENT_PRIMARY};
    }

    :last-child {
      width: 24px;
      background-color: ${constants.CORE_PRIMARY};
      border-right: 1px solid ${constants.CORE_PRIMARY_2};
    }
  }
`

export const PriceContainer = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding-right: 5px;

  ${PriceHeader}, ${PriceRow} {
    width: 100%;
    display: flex;

    font-size: 12px;
    font-weight: ${constants.FontWeight.Normal};
    color: ${constants.CORE_PRIMARY_6};
    text-align: left;

    span {
      display: flex;
      align-items: center;

      :first-child {
        flex: 0 0 100px;
      }

      :nth-child(2) {
        flex: 1;
        justify-content: flex-end;
      }

      :last-child {
        flex: 0 0 24px;
        padding: 0;
      }
    }
  }
`

export const RemovePriceButton = styled(RemoveItemButton)`
  svg {
    width: 12px;
    height: 12px;
    color: ${constants.CORE_PRIMARY_4};
  }
`
export const Content = styled(Groupbox)`
  padding: 20px 20px 0 20px;
  min-height: 450px;
  overflow-y: auto;
  width: 450px;
`
